import styles from './InputText.module.scss';

export default function InputTextComponent({ value, setValue, variant, placeholder, min, max, ...props }) {
    const classNames = styles[`redl-input-text-${variant}`];

    return (
        <input type="text" className={classNames} value={value} onChange={setValue} placeholder={placeholder}
               min={min} max={max} {...props} />
    );
}